export const TOAST = {
  agent: {
    created: "Your agent is ready to configure",
    saved: "Agent details updated",
    deleted: "Agent removed",
  },
  app: {
    exported: "Client exported successfully",
    exportError: "Export failed — please try again",
  },
  clients: {
    imported: (count) => `${count} ${count === 1 ? "file" : "files"} imported successfully`,
    importError: "Import failed — please try again",
    loadFilesError: "Could not load export files — please try again",
  },
  businessUnit: {
    deleted: "Business unit removed",
  },
  capability: {
    enabled: "Capability is now active",
    saved: "Capability settings saved",
    disabled: "Capability turned off",
    jsonError: "Please fix the JSON errors before saving",
    jsonErrorEnable: "Please fix the JSON errors before enabling",
    selectAtLeastOne: "Please select at least one capability",
    attached: (count) =>
      `${count} ${
        count === 1 ? "capability" : "capabilities"
      } added successfully`,
    instanceNameRequired: "Capability name is required",
    configUpdated: "Capability settings updated",
    detached: "Capability removed from agent",
    typeRequired: "Please select a capability type",
    jsonValidationError: "Please fix the JSON errors before saving",
    configError: (errors) => `Please fix the following: ${errors.join(", ")}`,
  },
  instructions: {
    saved: "Instructions saved",
  },
  websites: {
    statusUpdateError: (status) =>
      `Could not update URLs to "${status}" — please try again`,
    exported: "URLs exported successfully",
    exportError: "Export failed — please try again",
    refreshDaysError: "Refresh interval must be between 1 and 365 days",
    tagsUpdateError: "Could not update tags — please try again",
  },
  appearance: {
    saved: "Appearance settings saved",
  },
  inputPrompts: {
    saved: "Input prompts saved",
    deleteError: "Could not delete prompt — please try again",
  },
  urlWeightage: {
    formatError: "Could not parse the URL weightage values",
    saved: "URL weightages saved",
    saveError: "Could not save URL weightages — please try again",
    noConfigs: "No configurations to save",
    pushed: (env) =>
      `Changes pushed to ${env === "stage" ? "Staging" : "Production"}`,
    pushError: "Push failed — please try again",
    pushNetworkError: "Something went wrong while pushing — please try again",
  },
  repository: {
    synced: "Repository synced successfully",
    requiredFields: "Name and repository type are required",
  },
  agentVariable: {
    created: "Variable added successfully",
    saved: "Variable updated",
    deleted: "Variable removed",
  },
};
